<template lang="pug">
  b-form(@submit.stop.prevent="onSubmit").service-folder-create-edit-form
    b-form-group(
      label="Nombre"
      label-for="input-folder-name"
    )
      b-form-input#input-folder-name(
        v-model="name"
        placeholder="Nueva carpeta"
        :state="$v.$dirty ? !$v.name.$invalid : null"
      )
      .errors(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.name.required") Campo requerido
        b-form-invalid-feedback(:state="$v.name.maxLength") El nombre no debe tener más de 255 caracteres
    .modal-footer
      b-button(@click="$emit('cancel')" variant="outline-muted") Cancelar
      b-button.boton(type="submit" @click="" variant="secondary") {{editMode?'Guardar':'Agregar'}}
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  props: {
    editMode: Boolean,
    serviceId: Number,
    parentFolderId: Number,
    folder: Object
  },
  data () {
    return {
      name: this.editMode ? this.folder.name : ''
    }
  },
  validations: {
    name: { 
      required,
      maxLength: maxLength(255)
    }
  },
  methods: {
    ...mapActions(['createServiceFolder', 'updateServiceFolder']),
    async onSubmit () {
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        const action = this.editMode ? this.updateServiceFolder : this.createServiceFolder
        let data = {}
        data.name = this.name
        if (this.editMode) {
          // Editando carpeta
          data.id = this.folder.id
        } else {
          // Creando carpeta
          if (this.parentFolderId) {
            // Es una subcarpeta
            data.parentFolderId = this.parentFolderId
          } else {
            // Es una carpeta principal
            data.serviceId = this.serviceId
          }
        }
        // Crea o edita una carpeta
        const response = await action({ data, serviceId: this.serviceId })
        
        if (response.status >= 400) {
          const msg = response.data.errors[0]
          this.$root.$bvToast.toast(msg, {
            title: 'Oops!!',
            variant: 'danger'
          })
        }
        this.$emit('done')
      }
    }
  }
}
</script>

